import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-292" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-293" data-mp="3fxb4so7r80et">
        <h2 id="testimonials-title" className="text-center font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-294" data-mp="3azt2vhs5mlgb">
          What other <em className="text-brand-600" data-id="element-295" data-mp="36wmrjvq6q42z">dentists</em> are saying
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-296" data-mp="31yl8vbwo86s1">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-brand-100 bg-cream p-6" data-id="element-297" data-mp="2x2mmtuytf0us">
              <div className="flex gap-0.5 text-amber-400" aria-label="5 out of 5 stars" data-id="element-298" data-mp="v9gahoeeu4po">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-299" data-mp="qbn690wo3ks1" data-mpi={i} />)}
              </div>
              <p className="mt-4 font-serif text-xl font-bold leading-snug text-brand-800" data-id="element-300" data-mp="h818trjkkmm2">“{t.headline}”</p>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-ink" data-id="element-301" data-mp="m2onkyoru2ng">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-302" data-mp="7a4ukqvc5bjq">
                <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-brand-200" loading="lazy" data-id="element-303" data-mp="c73q9dundqk1" />
                <div data-id="element-304" data-mp="q6mmb8a6pbfz">
                  <p className="font-extrabold text-ink" data-id="element-305" data-mp="q766ywr7ydxp">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-306" data-mp="q4s9yiczarni">{t.country}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CtaButton className="mt-12" label="I want a clearer CBCT review process" data-id="element-307" data-mp="1iuii8arxizbp" />
      </div>
    </section>;
}